import './NotFound.scss'
import content from './content.json'
import {Page} from '../../layouts/page/Page'
import {Button} from '../../components/button/Button'
import config from '../../config'
import {useNavigate} from 'react-router'

export const NotFoundPage = () => {
    const navigate = useNavigate()
    return (
        <Page id="not-found">
            <h1>{content?.title}</h1>
            <p>{content?.text}</p>
            <Button variant={'primary'} onClick={() => navigate(config.root)}>{content?.linkText}</Button>
        </Page>
    )
}